const Password = require('common/models/password')
const i18n = { __:require('common/hbs-helpers/__') }

class FormPasswordSet extends require('common/helpers/validate') {
   // Validation schema
   get schema() {
      return {
         username: {
            type: 'string'
         },
         names: {
            type: 'string',
         },
         newpassword: {
            type: 'password',
            required: true
         },
         newpassword2: {
            same: 'newpassword',
            required: true
         }
      }
   }

   get messages() {
      return {
         'newpassword.required': i18n.__('msg:error enter password'),
         'newpassword2.required': i18n.__('msg:error enter password again'),
         'newpassword2.same': i18n.__('msg:error enter password again')
      }
   }
}

module.exports = FormPasswordSet
